import { assertResponseError } from './assert';
import { prepareRegionSuggests } from '../../mappers/regionSuggests';
import {
  fetchCianApiSiteV1SearchRegionsCities,
  ICianApiSiteV1SearchRegionsCitiesRequest,
  TCianApiSiteV1SearchRegionsCitiesResponse,
} from '../../repositories/monolith-python/cian-api/site/v1/search-regions-cities';
import { IApplicationContext } from '../../types/applicationContext';
import { IRegion } from '../../types/requestForm/requestFormV2';

export const searchRegionSuggests = async (
  context: IApplicationContext,
  parameters: ICianApiSiteV1SearchRegionsCitiesRequest,
): Promise<IRegion[]> => {
  const {
    httpApi,
    logger,
    custom: { subdomain },
  } = context;

  try {
    const response: TCianApiSiteV1SearchRegionsCitiesResponse = await fetchCianApiSiteV1SearchRegionsCities({
      httpApi,
      parameters,
      config: {
        subdomain,
      },
    });

    assertResponseError(response);

    return prepareRegionSuggests(response.response.data);
  } catch (error) {
    logger.error(error, {
      comment: '[Degradation] Используется пустой список результатов поиска',
    });

    return [];
  }
};
